
<div class="store-crt">
  <h4>Enter Store Details</h4>
  <button class="closedialog cstm-close-btn" (click)="cancel()">
    <i class="material-icons">close    </i>
  </button>
  <form class="example-form" [formGroup]="createForm" (ngSubmit)="createStore(createForm)">
    <mat-form-field class="example-full-width">
      <input required matInput placeholder="Store Name" formControlName="StoreName" ng-model-options="{debounce: 10000}" (change)="fn_searchStore()">
      <mat-error *ngIf="!f.StoreName.valid && f.StoreName.touched && (f.StoreName.pristine || f.StoreName.dirty)">
        Store Name is <strong>required</strong>
      </mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-select matInput placeholder="Select Category" formControlName="StoreCategories" required>
        <mat-option *ngFor="let category of storeCategories" [value]="category.StoreCategoryId">
          {{category.Name}}
        </mat-option>
        <!--<mat-option (click)="fn_AddCategory()">Others</mat-option>-->
      </mat-select>
    </mat-form-field>
    <mat-form-field class="example-full-width">
      <textarea required matInput placeholder="Description" formControlName="Description"></textarea>
      <mat-error *ngIf="!f.Description.valid && f.Description.touched && (f.Description.pristine || f.Description.dirty)">
        <strong>Required</strong>
      </mat-error>
    </mat-form-field>
    <button mat-raised-button [disabled]="createForm.invalid">Submit</button>
  </form>
</div>


